import { FlexContainer, Slide } from '@act/storybook';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';
import { useMobile } from '../../../../utilities/MobileContext';

export const ThankYouSlide = () => {
  const theme = useTheme();
  const { isMobile } = useMobile();

  return (
    <Slide
      sx={{
        cursor: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='46px' height='46px' viewBox='0 0 256 256'><path fill='%23ffffff' d='M111.49,52.63a15.8,15.8,0,0,0-26,5.77L33,202.78A15.83,15.83,0,0,0,47.76,224a16,16,0,0,0,5.46-1l144.37-52.5a15.8,15.8,0,0,0,5.78-26ZM65.14,161.13l19.2-52.79,63.32,63.32-52.8,19.2ZM160,72a37.8,37.8,0,0,1,3.84-15.58C169.14,45.83,179.14,40,192,40c6.7,0,11-2.29,13.65-7.21A22,22,0,0,0,208,23.94,8,8,0,0,1,224,24c0,12.86-8.52,32-32,32-6.7,0-11,2.29-13.65,7.21A22,22,0,0,0,176,72.06,8,8,0,0,1,160,72ZM136,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm101.66,82.34a8,8,0,1,1-11.32,11.31l-16-16a8,8,0,0,1,11.32-11.32Zm4.87-42.75-24,8a8,8,0,0,1-5.06-15.18l24-8a8,8,0,0,1,5.06,15.18Z'/></svg>") 0 0, auto`,
      }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 1.5 }}
      >
        <FlexContainer direction="column" gap={2}>
          {isMobile ? (
            // Mobile: Single paragraph
            <Typography
              variant="displayMedium"
              fontWeight="500"
              color="primary.contrastText"
              lineHeight="64px"
            >
              Thank you for helping make{` `}
              <motion.div
                initial={{ color: theme.palette.primary.contrastText }}
                animate={{ color: theme.palette.primaryAccent.main }}
                transition={{ delay: 1.5, duration: 0.75 }}
                style={{ display: 'inline' }}
              >
                R
              </motion.div>
              <motion.div
                initial={{ color: theme.palette.primary.contrastText }}
                animate={{ color: theme.palette.primaryAccent.main }}
                transition={{ delay: 1.62, duration: 0.75 }}
                style={{ display: 'inline' }}
              >
                e
              </motion.div>
              <motion.div
                initial={{ color: theme.palette.primary.contrastText }}
                animate={{ color: theme.palette.primaryAccent.main }}
                transition={{ delay: 1.74, duration: 0.75 }}
                style={{ display: 'inline' }}
              >
                e
              </motion.div>
              <motion.div
                initial={{ color: theme.palette.primary.contrastText }}
                animate={{ color: theme.palette.primaryAccent.main }}
                transition={{ delay: 1.86, duration: 0.75 }}
                style={{ display: 'inline' }}
              >
                m
              </motion.div>
              <motion.div
                initial={{ color: theme.palette.primary.contrastText }}
                animate={{ color: theme.palette.primaryAccent.main }}
                transition={{ delay: 1.98, duration: 0.75 }}
                style={{ display: 'inline' }}
              >
                a
              </motion.div>
              {` `}the company that it is today.
            </Typography>
          ) : (
            // Desktop: Two separate lines
            <FlexContainer direction="column" gap={2} alignItems="center">
              <Typography
                variant="displayMedium"
                fontWeight="500"
                color="primary.contrastText"
              >
                Thank you for helping make{` `}
                <motion.div
                  initial={{ color: theme.palette.primary.contrastText }}
                  animate={{ color: theme.palette.primaryAccent.main }}
                  transition={{ delay: 1.5, duration: 0.75 }}
                  style={{ display: 'inline' }}
                >
                  R
                </motion.div>
                <motion.div
                  initial={{ color: theme.palette.primary.contrastText }}
                  animate={{ color: theme.palette.primaryAccent.main }}
                  transition={{ delay: 1.62, duration: 0.75 }}
                  style={{ display: 'inline' }}
                >
                  e
                </motion.div>
                <motion.div
                  initial={{ color: theme.palette.primary.contrastText }}
                  animate={{ color: theme.palette.primaryAccent.main }}
                  transition={{ delay: 1.74, duration: 0.75 }}
                  style={{ display: 'inline' }}
                >
                  e
                </motion.div>
                <motion.div
                  initial={{ color: theme.palette.primary.contrastText }}
                  animate={{ color: theme.palette.primaryAccent.main }}
                  transition={{ delay: 1.86, duration: 0.75 }}
                  style={{ display: 'inline' }}
                >
                  m
                </motion.div>
                <motion.div
                  initial={{ color: theme.palette.primary.contrastText }}
                  animate={{ color: theme.palette.primaryAccent.main }}
                  transition={{ delay: 1.98, duration: 0.75 }}
                  style={{ display: 'inline' }}
                >
                  a
                </motion.div>
              </Typography>
              <Typography
                variant="displayMedium"
                fontWeight="500"
                color="primary.contrastText"
              >
                the company that it is today.
              </Typography>
            </FlexContainer>
          )}
        </FlexContainer>
      </motion.div>
    </Slide>
  );
};
